import React, { useCallback } from 'react'
import classnames from 'classnames'

type ToggleSwitchProps = {
  id: string
  onChange: () => void
  checked: boolean
  label?: React.ReactNode
  ariaLabel?: string
  className?: string
  labelPosition?: 'left' | 'right'
}

const ToggleSwitch = ({
  id,
  onChange,
  checked,
  label,
  ariaLabel,
  className,
  labelPosition = 'left'
}: ToggleSwitchProps) => {
  const handleKeyDown = useCallback(
    (e: React.KeyboardEvent) => {
      if (e.key === ' ' || e.key === 'Spacebar' || e.key === 'Enter') {
        e.preventDefault()
        onChange()
      }
    },
    [onChange]
  )

  const labelId = label ? `${id}-label` : undefined

  return (
    <div
      className={classnames(
        'toggleSwitchWithLabel',
        labelPosition === 'right' ? 'labelPositionRight' : 'labelPositionLeft',
        className
      )}
    >
      {label && (
        <label id={labelId} htmlFor={id}>
          {label}
        </label>
      )}
      <div
        className='toggleSwitch'
        onClick={onChange}
        tabIndex={0}
        role='switch'
        aria-checked={checked}
        aria-labelledby={labelId}
        aria-label={!labelId ? ariaLabel : undefined}
        onKeyDown={handleKeyDown}
      >
        <input
          id={id}
          type='checkbox'
          aria-labelledby={labelId}
          checked={checked}
          readOnly
        />
        <span className='slider'></span>
      </div>
    </div>
  )
}

export default ToggleSwitch
